import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { WarnNotificationsService } from 'app/services/warn-notification.service';
import { isNullOrUndefined } from 'util';

import { AccountService } from './account.service';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private _accountService: AccountService, 
        private _warnNotificationService:WarnNotificationsService,
        private _router: Router,
        ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url = "/"
        if (!this._accountService.isAuthenticated) {
            this._router.navigate(['auth/login']);
            return false;
        }

        if (route.routeConfig.path != "") {
            let split = route.routeConfig.path.split("/");
            url = "/" + split[0] + "/" + split[1];
        }

        let hasRouteAuthority;

        try {
            var role = await JSON.parse(localStorage.getItem("RoleMenu"));            
            hasRouteAuthority = role.find(x => x.menu.url == url);
        } catch (error) {
            console.warn(error);

        }

        if(localStorage.getItem("Contract")=="false" && parseInt(localStorage.getItem("CompanyID"))!=1){
            localStorage.clear();
            this._accountService.logout();
            this._router.navigate(['auth/login'])
            return false;
        }

        await this._warnNotificationService.getWarnReportNotifications(parseInt(localStorage.getItem('CompanyID'))) 

        if (url == "/" || url == "/apps/dashboard") {
            return true;
        }

        if (!isNullOrUndefined(hasRouteAuthority)) {
            return true;
        } else {
            this._router.navigate(['*'])
            return false;
        }
        
    }
    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var result = await this.canActivate(route, state);
        return result;

    }

}
